// Shared Google Maps JS loader.
// Both RouteMap and AddressAutocomplete import this — single script tag, single promise.
// Uses the classic pattern: libraries=... in the URL loads them synchronously with the API.

const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const SCRIPT_TAG = "data-sal-gmaps";

let mapsPromise = null;

const ready = () =>
  !!(window.google?.maps?.Map && window.google?.maps?.places?.Autocomplete);

export const loadMaps = () => {
  if (mapsPromise) return mapsPromise;
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (!GOOGLE_KEY) { mapsPromise = Promise.reject(new Error("no key")); return mapsPromise; }
  if (ready()) {
    mapsPromise = Promise.resolve(window.google.maps);
    return mapsPromise;
  }

  mapsPromise = new Promise((resolve, reject) => {
    const check = () => {
      if (ready()) { resolve(window.google.maps); return true; }
      return false;
    };

    const existing = document.querySelector(`script[${SCRIPT_TAG}]`);
    if (existing) {
      if (check()) return;
      existing.addEventListener("load", () => check());
      existing.addEventListener("error", () => reject(new Error("script error")));
      const poll = setInterval(() => {
        if (check()) clearInterval(poll);
      }, 100);
      setTimeout(() => { clearInterval(poll); if (!ready()) reject(new Error("timeout")); }, 15000);
      return;
    }

    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY}&libraries=places,geometry,routes,geocoding&v=weekly`;
    s.async = true; s.defer = true;
    s.setAttribute(SCRIPT_TAG, "1");
    s.onload = () => check();
    s.onerror = () => reject(new Error("script error"));
    document.head.appendChild(s);
  });
  mapsPromise.catch(() => { mapsPromise = null; });
  return mapsPromise;
};

export const hasGoogleKey = () => !!GOOGLE_KEY;
